module.exports = __webpack_public_path__ + "static/media/formats_pdf.7f4325c8.svg";